import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {
  /** @default 'outlined' */
  variant?: 'outlined' | 'filled';
}

const CopyIcon = ({ variant = 'outlined', ...props }: Props) => {
  return (
    <SvgIcon
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 28H16C14.9391 28 13.9217 27.5786 13.1716 26.8284C12.4214 26.0783 12 25.0609 12 24V16C12 14.9391 12.4214 13.9217 13.1716 13.1716C13.9217 12.4214 14.9391 12 16 12H24C25.0609 12 26.0783 12.4214 26.8284 13.1716C27.5786 13.9217 28 14.9391 28 16V24C28 25.0609 27.5786 26.0783 26.8284 26.8284C26.0783 27.5786 25.0609 28 24 28ZM16 14.6667C15.6464 14.6667 15.3072 14.8071 15.0572 15.0572C14.8071 15.3072 14.6667 15.6464 14.6667 16V24C14.6667 24.3536 14.8071 24.6928 15.0572 24.9428C15.3072 25.1929 15.6464 25.3333 16 25.3333H24C24.3536 25.3333 24.6928 25.1929 24.9428 24.9428C25.1929 24.6928 25.3333 24.3536 25.3333 24V16C25.3333 15.6464 25.1929 15.3072 24.9428 15.0572C24.6928 14.8071 24.3536 14.6667 24 14.6667H16Z"
        fill="currentColor"
      />
      <path
        d="M12.9733 20H7.56C6.61691 19.9965 5.71345 19.6203 5.04658 18.9534C4.37971 18.2866 4.00351 17.3831 4 16.44V7.56C4.00351 6.61691 4.37971 5.71345 5.04658 5.04658C5.71345 4.37971 6.61691 4.00351 7.56 4H16.44C17.3831 4.00351 18.2866 4.37971 18.9534 5.04658C19.6203 5.71345 19.9965 6.61691 20 7.56V12.5333H17.3333V7.56C17.3333 7.32307 17.2392 7.09585 17.0717 6.92832C16.9042 6.76079 16.6769 6.66667 16.44 6.66667H7.56C7.32307 6.66667 7.09585 6.76079 6.92832 6.92832C6.76079 7.09585 6.66667 7.32307 6.66667 7.56V16.44C6.66667 16.6769 6.76079 16.9042 6.92832 17.0717C7.09585 17.2392 7.32307 17.3333 7.56 17.3333H12.9733V20Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default CopyIcon;
